import { action } from 'typesafe-actions';
import { ITicker } from '@kattana-io/common';

const entity = 'watchlist';
const ADD = `${entity}/ADD`;
const ADD_SUCCESS = `${entity}/ADD_SUCCESS`;
const REMOVE = `${entity}/REMOVE`;
const REMOVE_SUCCESS = `${entity}/REMOVE_SUCCESS`;
const REMOVE_ARGS = `${entity}/REMOVE_ARGS`;
const ACTIVATE = `${entity}/ACTIVATE`;
const REFRESH = `${entity}/REFRESH`;

const actionAddWatchlist = (item: ITicker) => action(ADD, item);
const actionAddSuccessWatchlist = (item: ITicker) => action(ADD_SUCCESS, item);
const actionRemoveWatchlist = (id: number) => action(REMOVE, id);
const actionRemoveSuccessWatchlist = (id: number) => action(REMOVE_SUCCESS, id);
const actionActivateWatchlist = (index: number) => action(ACTIVATE, { index });
const actionRefreshWatchlist = (items: ITicker[]) => action(REFRESH, items);

export {
  ADD,
  ADD_SUCCESS,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_ARGS,
  REFRESH,
  ACTIVATE,
  actionAddWatchlist,
  actionAddSuccessWatchlist,
  actionRemoveWatchlist,
  actionRemoveSuccessWatchlist,
  actionActivateWatchlist,
  actionRefreshWatchlist,
};
